/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import AchievementCategoryName from '../../../common/components/AchievementCategoryName';

export default class AchievementCategoriesDropdown extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { achievement_categories, categoryId } = this.attrs;

		return (
			<SelectDropdown buttonClassName="Button" className="AchievementCategoriesDropdown" caretIcon="fas fa-chevron-down">
				{achievement_categories?.map((category) => (
					<LinkButton
						href={app.route('achievements', {
							category: category.id(),
						})}
						active={+category.id() === +categoryId}
					>
						<AchievementCategoryName category={category} />
					</LinkButton>
				))}
			</SelectDropdown>
		);
	}
}
